import React, { useState, useEffect, Fragment } from "react";
import {
    Row,
    Label,
    Button,
    ModalBody,
    ModalFooter,
    Card,
    CardBody, Input
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import InsertText from '../../../../pages/integration/data/insert-text-at-cursor';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
            { list: 'ordered' },
            { list: 'bullet' },
            { indent: '-1' },
            { indent: '+1' },
        ],
        ['link'],
        ['clean'],
    ],
};

const quillFormats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
];
const MyTextbox = React.forwardRef(({ contents, onChange }, ref) => {
    let myContents = contents;
    return (
        <Input
            type="textarea"
            ref={ref}
            name="messageTextEmail"
            onChange={onChange}
            placeholder="What to send"
            value={myContents}
            id={"messageTextEmail"}
            rows={5}
        />
    );
});
const placeholders = [
    { value: "{{FIRST_NAME}}" },
    { value: "{{LAST_NAME}}" },
    { value: "{{CHECK_IN}}" },
]
export default function EmailAction({ visible, toggle, submit, inputData }) {
    const textbox = React.createRef();
    const [selectedTokens, setSelectedTokens] = useState([]);
    const [emailInputData, setEmailInputData] = useState({
        type: "Email",
        messageText: "",
        buttons: []
    });
    useEffect(() => {
        if (inputData.length > 0) {
            var data = inputData[0];
            if (data !== undefined) {
                setEmailInputData(data);
            }
        }
    }, [inputData]);
    function generateRandomColor(index) {
        var arr = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'danger',
            'light',
            'dark',
        ];
        return arr[Math.floor(Math.random() * arr.length)];
    }
    const handleInsert = (name) => {
        var text = document.getElementById("messageTextEmail");
        text.focus();
        InsertText(textbox.current, name);
    };
    const handleDescriptionChange = (evt) => {
        let s = evt.target.value;
        let tok = [];
        placeholders.map((items) => {
            if (s.includes(items.value)) {
                tok.push({
                    value: items.value
                })
            }
        });
        setSelectedTokens(tok);
        setEmailInputData({
            ...emailInputData,
            messageText: s,
        });
    };
    const handleSubmit = () => {
        submit(emailInputData);
    }
    return (
        <Fragment>
            <ModalBody>
                <Card>
                    <CardBody>
                        <Row>
                            <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                <Label>What to Send</Label>
                                <MyTextbox
                                    contents={emailInputData.messageText}
                                    ref={textbox}
                                    onChange={(e) => handleDescriptionChange(e)}>
                                </MyTextbox>
                            </Colxx>
                            <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                <Label>Insert Placeholder</Label>
                                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                    {placeholders.map((token, index) => {
                                        return (
                                            <div key={index} style={{ marginRight: "1.5px" }}>
                                                <Button
                                                    color={generateRandomColor(index)}
                                                    className="mb-2"
                                                    outline
                                                    size="xs"
                                                    onClick={() => handleInsert(token.value)}
                                                >{token.value}</Button>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Colxx>
                        </Row>
                    </CardBody>
                </Card>
            </ModalBody>
            <ModalFooter>
                <Button color="primary"
                    onClick={handleSubmit}
                >
                    Create
                </Button>
                <Button color="secondary"
                    onClick={toggle}
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Fragment>
    )
}